import * as React from "react";
import { FeedbackButton } from "./FeedbackButton";
import { FeedbackSidebar } from "./FeedBackSidebar";
import { FeedbackPopup } from "./FeedBackPopup";

export function Feedback() {
  const [isOpen, setIsOpen] = React.useState(false);
  const [showPopup, setShowPopup] = React.useState(false);

  const handleSubmit = async (formData) => {
    // Handle form submission logic here
    setIsOpen(false);
    setShowPopup(true);
  };

  const handlePopupSubmit = (rating) => {
    setShowPopup(false);
  };

  return (
    <>
      <FeedbackButton onOpen={() => setIsOpen(!isOpen)} isOpen={isOpen} />
      <FeedbackSidebar
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onSubmit={handleSubmit}
      />
      {showPopup && (
        <FeedbackPopup onClose={() => setShowPopup(false)} onSubmit={handlePopupSubmit} />
      )}
    </>
  );
}
